export default "/_next/static/9c14ae7160064a84e479c3277f6b115c.png";